import moment from 'moment';

import {NCE_TRIAL_CAMPAIGN_TITLES} from 'static/three-oh/src/modules/constants/trialLicenseCampaigns';

export const productTextMap = {
  collections: 'Collections',
  ela: 'Newsela ELA',
  science: 'Newsela Science',
  stem: 'Newsela STEM',
  everwrite: 'Newsela Writing',
  social_studies: 'Newsela Social Studies',
  essentials: 'Newsela Essentials',
  power_words: 'Power Words',
  teacher_learning_hub: 'PL Pass',
  nce_trial_campaign: 'Newsela Certified Educator Trial'
};

export const getExpirationDateFor = (licenseType, product, licenses) => {
  const expirationDate = licenses.find((license) => product.includes(license[licenseType]))?.date_ends;
  return expirationDate ? moment(expirationDate).format('MMM DD, YYYY') : null;
};

export const getLicensesLists = (hasNceTrialCampaign, licenses = []) => {
  let trials = {};
  const subscriptions = {};
  for (const license of licenses) {
    if (!license.is_active) continue;

    if (!license.is_trial) {
      subscriptions[license.product] = license;
      continue;
    }

    const currentExpiration = moment(license.date_ends);
    const storedExpiration = moment(trials[license.product]?.expirationDate);

    if (!trials[license.product] || currentExpiration > storedExpiration) {
      trials[license.product] = {
        ...license,
        expirationDate: license.date_ends
          ? moment(license.date_ends).format('MMM DD, YYYY')
          : null,
      };
    }
  }

  if (hasNceTrialCampaign) {
    trials = {
      nce_trial_campaign: {
        product: 'nce_trial_campaign',
        expirationDate: getExpirationDateFor('campaign', NCE_TRIAL_CAMPAIGN_TITLES, licenses)
      }
    };
  }

  return [Object.values(trials), Object.values(subscriptions)];
};

export const getSubscriptionsInformation = (licenses) => {
  const hasStem = licenses?.some((item) => item.product === 'stem');
  const hasScience = licenses?.some((item) => item.product === 'science');
  const hasBothSTEMAndScience = hasStem && hasScience;

  return licenses.reduce((array, {product, expirationDate, date_ends: dateEnds}) => {
    if (productTextMap[product]) {
      // Don't display Science if a user also has STEM license.
      if (hasBothSTEMAndScience && product === 'science') {
        return array;
      }

      array.push({
        product: productTextMap[product] || '',
        expirationDate: expirationDate ?? dateEnds
      });
    }
    return array;
  }, []);
};
